export const DateFormatter = (date: Date): string => {
    return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
};

